import {
  Box,
  TextField,
  Typography,
  Stack,
  Paper,
  Chip,
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import CampaignIcon from "@mui/icons-material/Campaign";

export default function CampaignDetailsSection({
  formData,
  errors,
  onChange,
}) {
  const theme = useTheme();

  return (
    <Paper
      variant="outlined"
      sx={{
        p: { xs: 2.5, md: 3.5 },
        mb: 3,
        borderRadius: 3,
        borderColor: errors.name ? theme.palette.error.main : "divider",
      }}
    >
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 3 }}>
        <CampaignIcon sx={{ color: theme.palette.primary.main, fontSize: 22 }} />
        <Typography sx={{ fontSize: 17, fontWeight: 700, color: "text.primary" }}>
          Campaign Details
        </Typography>
      </Stack>

      <Stack spacing={3}>
        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>
              Campaign Name
            </Typography>
            <Chip label="Required" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: theme.palette.primary.main, color: "#fff", textTransform: "uppercase", letterSpacing: 0.5 }} />
          </Stack>
          <TextField
            fullWidth
            size="small"
            placeholder="e.g. Diwali Offer 2026"
            value={formData.name}
            onChange={(e) => onChange("name", e.target.value)}
            error={!!errors.name}
            helperText={errors.name}
            sx={inputSx}
          />
        </Box>

        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>
              Campaign Tag / Label
            </Typography>
            <Chip label="Optional" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: "#f1f5f9", color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5 }} />
          </Stack>
          <TextField
            fullWidth
            size="small"
            placeholder="e.g. festive, promo, follow-up"
            value={formData.tag}
            onChange={(e) => onChange("tag", e.target.value)}
            sx={inputSx}
          />
        </Box>

        <Box>
          <Stack direction="row" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
            <Typography sx={{ fontSize: 13, fontWeight: 600, color: "#475569" }}>
              Description
            </Typography>
            <Chip label="Optional" size="small" sx={{ height: 20, fontSize: 10, fontWeight: 600, bgcolor: "#f1f5f9", color: "#94a3b8", textTransform: "uppercase", letterSpacing: 0.5 }} />
          </Stack>
          <TextField
            fullWidth
            size="small"
            multiline
            rows={3}
            placeholder="Brief description of this campaign..."
            value={formData.description}
            onChange={(e) => onChange("description", e.target.value)}
            sx={inputSx}
          />
        </Box>
      </Stack>
    </Paper>
  );
}

const inputSx = {
  "& .MuiOutlinedInput-root": {
    bgcolor: "#f8fafc",
    borderRadius: 2,
    "& fieldset": { borderColor: "#e2e8f0" },
    "&:hover fieldset": { borderColor: "#cbd5e1" },
    "&.Mui-focused fieldset": { borderColor: "primary.main" },
  },
};
